import { CSSProperties, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './styles/styles.module.scss';

type ControlContainerProps = {
  children: ReactNode;
  className?: string;
  compactSpacing?: boolean; // The default for the new explore map controls - likely to become the default for the maps package as a whole
  id?: string;
  position: 'bottomCenter' | 'bottomLeft' | 'bottomRight' | 'topCenter' | 'topLeft' | 'topRight';
  style?: CSSProperties;
};

const ControlContainer = ({ children, className, compactSpacing, id, position, style }: ControlContainerProps) => {
  return (
    <div className={classNames(styles.container, styles[position], { [styles.compact]: compactSpacing }, className)} id={id} style={style}>
      {children}
    </div>
  );
};

export default ControlContainer;
